import {
  Activity,
  BarChart3,
  Bell,
  BookOpenCheck,
  Bot,
  Braces,
  Building2,
  CheckSquare,
  Clock,
  Circle,
  ClipboardList,
  CreditCard,
  FileInput,
  FileText,
  FileStack,
  FolderKanban,
  Globe,
  Inbox,
  LayoutDashboard,
  MessageSquareText,
  MonitorCog,
  NotebookPen,
  PhoneCall,
  PlusSquare,
  Receipt,
  Repeat,
  Rocket,
  Send,
  Settings,
  ShieldCheck,
  Sparkles,
  UserPlus,
  Users,
  WalletCards,
  Wrench,
  type LucideIcon,
} from 'lucide-react';

/**
 * Map icon names used in apps/admin-oneup/src/portal.config.ts to the
 * Lucide components apps/web actually renders. Add new entries here when
 * the admin config introduces a new icon name.
 */
const ICONS: Record<string, LucideIcon> = {
  Activity,
  BarChart3,
  Bell,
  BookOpenCheck,
  Bot,
  Braces,
  Building2,
  CheckSquare,
  Clock,
  ClipboardList,
  CreditCard,
  FileInput,
  FileText,
  FileStack,
  FolderKanban,
  Globe,
  Inbox,
  LayoutDashboard,
  MessageSquareText,
  MonitorCog,
  NotebookPen,
  PhoneCall,
  PlusSquare,
  Receipt,
  Repeat,
  Rocket,
  Send,
  Settings,
  ShieldCheck,
  Sparkles,
  UserPlus,
  Users,
  WalletCards,
  Wrench,
};

const FALLBACK_ICON: LucideIcon = Circle;

export function resolveIcon(name: string | undefined): LucideIcon {
  if (!name) return FALLBACK_ICON;
  return ICONS[name] ?? FALLBACK_ICON;
}
